import {InfoCircleOutlined} from '@ant-design/icons';
import {Popover} from 'antd';
import React from 'react';

import dataCollectorTransferStatuses from '../../../consts/dataCollector/dataCollectorTransferStatuses.ts';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import stylesService from '../../../services/styles/stylesService';
import DataCollectorInfoPopover from '../../DataCollectorInfoPopover/DataCollectorInfoPopover';
import StatusBadge from '../../StatusBadge/StatusBadge';

const DrawerSectionDataCollector = ({uspds, mobile = false}) => {
    const localizedStrings = getLocalizedStrings();

    if (!uspds || uspds.length === 0) return null;

    if (mobile) {
        const statusLabels = {
            [dataCollectorTransferStatuses.AllDevicesWithoutErrors]:
                localizationKeys.DATA_COLLECTOR_STATUS_ALL_DEVICES_WITHOUT_ERRORS,
            [dataCollectorTransferStatuses.NoDataRetrieved]: localizationKeys.DATA_COLLECTOR_STATUS_NO_DATA_RETRIEVED,
            [dataCollectorTransferStatuses.AllDevicesWithErrors]:
                localizationKeys.DATA_COLLECTOR_STATUS_ALL_DEVICES_WITH_ERRORS,
            [dataCollectorTransferStatuses.SomeDevicesWithErrors]:
                localizationKeys.DATA_COLLECTOR_STATUS_SOME_DEVICES_WITH_ERRORS,
            [dataCollectorTransferStatuses.TimepointsDoNotMatchWithCurrentDate]:
                localizationKeys.DATA_COLLECTOR_STATUS_TIMEPOINTS_DO_NOT_MATH_WITH_CURRENT_DATE,
            [dataCollectorTransferStatuses.DataTransferDisabled]:
                localizationKeys.DATA_COLLECTOR_STATUS_DATA_TRANSFER_DISABLED,
        };

        return (
            <section className='map-building-mobile-section'>
                <h3>{localizedStrings[localizationKeys.DCTD_TEXT]}</h3>
                <ul className='map-building-mobile-modems' role='list'>
                    {uspds.map((uspd) => (
                        <li key={uspd.id}>
                            <div className='map-building-mobile-modem-number'>{uspd.deviceNumber || '—'}</div>
                            {uspd.name && <div className='map-building-mobile-modem-name'>{uspd.name}</div>}
                            {statusLabels[uspd.transferStatus] && (
                                <div className='map-building-mobile-modem-status'>
                                    <StatusBadge
                                        statusColor={`!mr-0 ${
                                            stylesService.statusColorClassNames[uspd.transferStatus]
                                        }`}
                                    />
                                    <span>{localizedStrings[statusLabels[uspd.transferStatus]]}</span>
                                </div>
                            )}
                            <dl className='map-building-mobile-modem-values'>
                                <div>
                                    <dt>{localizedStrings[localizationKeys.DC_PAGE_TABLE_HEADER_IP_ADDRESS]}</dt>
                                    <dd>{uspd.ipAddress || '—'}</dd>
                                </div>
                                <div>
                                    <dt>{localizedStrings[localizationKeys.DC_PAGE_TABLE_HEADER_SIM_NUMBER]}</dt>
                                    <dd>{uspd.simNumber || '—'}</dd>
                                </div>
                            </dl>
                        </li>
                    ))}
                </ul>
            </section>
        );
    }

    return (
        <section className={'pb-1 rounded-10'}>
            <div className={'mb-1 flex items-center justify-center gap-1.5'}>
                <div className={'text-16 font-bold text-zambezi'}>{localizedStrings[localizationKeys.DCTD_TEXT]}</div>

                <Popover overlayClassName={'max-w-[250px]'} content={<DataCollectorInfoPopover />}>
                    <InfoCircleOutlined
                        className={'cursor-pointer text-zambezi/70 hover:text-primary transition-colors'}
                    />
                </Popover>
            </div>

            <div className={'flex flex-col gap-1'}>
                {uspds.map((uspd) => (
                    <div
                        key={uspd?.id}
                        className={
                            'bg-whisper/40 px-2 py-1 hover:bg-whisper/70 transition-colors border-b-solitude border-b'
                        }
                    >
                        <div className={'map-building-data-collector-row flex items-start justify-between gap-4'}>
                            <div className={'flex flex-col min-w-0'}>
                                <div className={'flex items-center gap-2'}>
                                    <StatusBadge
                                        statusColor={`!w-3 !h-3 !mr-0 ${
                                            stylesService.statusColorClassNames[uspd?.transferStatus]
                                        }`}
                                    />
                                    <span className={'leading-12 font-medium text-14 text-zambezi whitespace-nowrap'}>
                                        {uspd?.deviceNumber || '-'}
                                    </span>
                                </div>
                                {uspd?.name && (
                                    <div
                                        className={
                                            'pl-[20px] text-12 text-zambezi opacity-70 break-words leading-12 mt-0.5'
                                        }
                                    >
                                        {uspd.name}
                                    </div>
                                )}
                            </div>

                            <div className={'map-building-data-collector-values flex items-start gap-4 flex-shrink-0'}>
                                <div className={'flex flex-col items-center'}>
                                    <div className={'text-14 text-zambezi leading-12'}>{uspd?.ipAddress || '-'}</div>
                                    {uspd?.ipAddress && <div className={'text-10 text-manatee mt-0.5'}>IP-адреса</div>}
                                </div>

                                <div className={'flex flex-col items-center w-[110px]'}>
                                    <div className={'text-14 text-zambezi leading-12'}>{uspd?.simNumber || '-'}</div>
                                    {uspd?.simNumber && (
                                        <div className={'text-10 text-manatee mt-0.5'}>Номер телефону</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default DrawerSectionDataCollector;
